import React, {useEffect} from "react";
import {observer} from "mobx-react";
import merchantStoresMenuStore from "./merchant-portal-menu-list-store";
import CurrentPortal from "./current-portal/current-portal";
import PortalSelect from "./portal-select/portal-select";
import currentAccountStore from "../../../../../pages/accounts/stores/current-account-store";
import shopSwitchStore from "../../../../../pages/user-master-list/modals/components/shop-switch-reason-handler/shop-switch-store";
import { isSet } from '../../../../../models/model-types-methods';
import {ADMIN_ROLES} from "../../../../../models/User";
import dashboardSettingsStore from "../../../../../stores/dashboard-settings-store";

type MerchantPortalsMenuProps = {}

const MerchantPortalsMenu: React.FC<MerchantPortalsMenuProps> = observer(() => {
    useEffect(() => {
        merchantStoresMenuStore.loadPortals().then(() => {
            if (dashboardSettingsStore.portalId) {
                merchantStoresMenuStore.findAndSetSelectedPortalById(dashboardSettingsStore.portalId);
            }
        });
    }, []);

    const shops = merchantStoresMenuStore.portals;

    const onPortalChange = async (portalId: string|number): Promise<void> => {
        const isAdmin = currentAccountStore.isSysAdmin;
        const hasEditorRole = currentAccountStore.hasRole(ADMIN_ROLES.EDITOR);
        let reason;

        if (isAdmin && hasEditorRole) {
            reason = await shopSwitchStore.askForReason();

            if (!isSet(reason)) {
                return;
            }
        }
        await merchantStoresMenuStore.changePortal(portalId, reason);
    }

    const showPortalsSelection = (): boolean => {
        /** If by some reason there is no shops - do not show selection dropdown */
        if (!shops) {
            return false;
        }

        /** If there are more than 1 shop, or 1 shop with multiple portals - show selection dropdown */
        const singleShopPortalsCount = Object.values(shops[0]?.portals ?? {}).length ?? 0;
        if (shops.length > 1 || singleShopPortalsCount > 1) {
            return true;
        }

        return false;
    }

    return showPortalsSelection()
        ? <PortalSelect onPortalChange={onPortalChange} />
        : <CurrentPortal portalName={merchantStoresMenuStore.selectedPortal?.label as string} />
});

export default MerchantPortalsMenu;